module.exports = __webpack_public_path__ + "static/media/image_22.1720ecc1.png";